import { render, staticRenderFns } from "./MyInspectors.vue?vue&type=template&id=c1930d50&scoped=true&"
import script from "./MyInspectors.vue?vue&type=script&lang=js&"
export * from "./MyInspectors.vue?vue&type=script&lang=js&"
import style0 from "./MyInspectors.vue?vue&type=style&index=0&id=c1930d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1930d50",
  null
  
)

export default component.exports